<ul>
  <li *ngFor="let tab of tabs" routerLinkActive="active">
    <a  
      [routerLink]="['/'+tab.url]" title="{{tab.nombre}}" >{{ tab.nombre | translateV2 }}</a>
  </li>
</ul>


